import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Params } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { Globals } from './../../globals'
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-extension-back',
  templateUrl: './extension-back.component.html',
  providers: [DatePipe]
})
export class ExtensionBackComponent implements OnInit {
  public errorMessage;
  public okMessage;
  public postId;
  public idImport;
  public accion;
  public volver;
  public titulo: string = "Gestionar importación";
  public today;
  public dateend;
  public lenguajeGlobal;

  public numeroautorizacion;
  public nombreturista: string;
  public pasaporte: string;
  public email: string;
  public numeroserial: string;
  public seccionalsalida: string;
  public fecharegistro: string;
  public estado: string;
  public idestado: string;

  public numeroserialprorroga: string;
  public numeroserialapoderado: string;  
  
  public solicitudmandato: string = "0";
  public mandatocheckSi = false;
  public mandatocheckNo = true;
  public ApoderadoShow = false;
    
  ShowTouristData = true;
  ShowTransportData = false;
  ShowLoadedFiles = false;
  TDNoSelect = false; TDSelect = true;
  TRSelect = false; TRNoSelect = true;
  LFSelect = false; LFNoSelect = true;

  public GestionarShow = true;
  public ConsultarShow = false;
  public ProrrogaShow = false;
  public EditarShow = false;
  public ShowRejection = false;

  public showModalBoxCancelar = false;
  public showModalBoxsave = false;
  showModalRequired: boolean = false;

  Seccionales: SeccionalAduanera[];
  Ciudades: Ciudad[];
  TiposID: TipoIdentificacion[];

  import: Import;
  imports: Import[];
  extend: Extend;
  extends: Extend[];
  user: User;

  errordiasAutorizadosId: boolean = false;
  erroraduanaIngreso: boolean = false;
  errornoDiasAutorizados: boolean = false;
  errorfechaInicioProrroga: boolean = false;
  errorfechaFinProrroga: boolean = false;
  errorciudadHospedajeTurista: boolean = false;
  errordireccionHospedajeTurista: boolean = false;
  errorcarMedioTransporte: boolean = false;
  errortipoIdApoderado: boolean = false;
  errornumeroIdApoderado: boolean = false;
  errornombreRazonSocialApoderado: boolean = false;
  errorcorreoElectronicoApoderado: boolean = false;

  public sendmail: SendMail;

  public tooladuanaIngreso: string;
  public toolciudadHospedajeId: string;
  public tooltipoIdApoderado: string;

  extensionForm = this.formBuilder.group({
    aduanaIngreso: new FormControl('', [Validators.required]),
    noDiasAutorizados: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]*$/)]),
    fechaInicioProrroga: new FormControl('', [Validators.required]),
    fechaFinProrroga: new FormControl('', [Validators.required]),
    ciudadHospedajeTurista: new FormControl('', [Validators.required]),
    direccionHospedajeTurista: new FormControl('', [Validators.required]),
    carMedioTransporte: new FormControl('', [Validators.required]),
    si_mandato: new FormControl(''),
    no_mandato: new FormControl(''),
    tipoIdApoderado: new FormControl(''),
    numeroIdApoderado: new FormControl(''),
    nombreRazonSocialApoderado: new FormControl(''),
    correoElectronicoApoderado: new FormControl(''),
    justification: new FormControl(''),
    justificationRejection: new FormControl(''),
    customTarget: new FormControl('')
  });

  constructor(private http: HttpClient, private formBuilder: FormBuilder, private rutaActiva: ActivatedRoute, private datePipe: DatePipe, private router: Router, private globals: Globals, private cookies: CookieService) {
    var token = this.cookies.get("tokensessionFuncionario");
    var lenguaje = this.cookies.get("lenguajeFuncionario");
    this.lenguajeGlobal = lenguaje;
    if (token == "") {
      window.location.href = environment.redirecturl;
    }
    else {
      this.http.get<any>(`${environment.baseUrl}v1/sessionfuncionario/1?token=` + this.cookies.get("tokensessionFuncionario"))
        .subscribe({
          next: data => {
            this.user = data as User;

            this.globals.tipoDocumento = this.user.tipoDocumento;
            this.globals.numIdentificacion = this.user.numIdentificacion;
            this.globals.nombres = this.user.nombres;
            this.globals.apellidos = this.user.apellidos;
            this.globals.seccional = this.user.seccional;
            this.globals.idSeccional = this.user.idSeccional;
            this.globals.dependencia = this.user.dependencia;
            this.globals.idDependencia = this.user.idDependencia;
            this.globals.correo = this.user.correo;
            this.globals.activo = this.user.activo;
            this.globals.roles = this.user.rolesAutorizados.split(",");

            for (let i = 0; i < this.globals.roles.length; i++) {
              if (this.globals.roles[i] == "3244") {
                this.globals.r3244 = true;
              }
              if (this.globals.roles[i] == "3246") {
                this.globals.r3246 = true;
              }
              if (this.globals.roles[i] == "3247") {
                this.globals.r3247 = true;
              }
            }
          },
          error: error => {
            this.errorMessage = error.message;
          }
        })
    }
  }

  get customTargetValue() { return this.extensionForm.get('customTarget'); }

  ngOnInit() {
    var lenguaje = this.cookies.get("lenguajeFuncionario");
    this.lenguajeGlobal = lenguaje;
    let element: HTMLElement = document.getElementById('abrircargando') as HTMLElement;
    element.click();
    this.accion = this.rutaActiva.snapshot.params.accion
    this.idImport = this.rutaActiva.snapshot.params.idimport
    this.postId = this.rutaActiva.snapshot.params.idextend
    this.volver = this.rutaActiva.snapshot.params.volver

    if (this.accion == "gestion") {
      this.GestionarShow = true;
      this.ConsultarShow = false;
      this.EditarShow = false;
    } else if (this.accion == "consulta") {
      this.GestionarShow = false;
      this.ConsultarShow = true;
      this.EditarShow = false;
      this.titulo = "Gestionar importación / Ver solicitud";
    }

    //this.email = this.rutaActiva.snapshot.params.email
    //this.numeroserial = this.rutaActiva.snapshot.params.numserial
    //this.numeroserialprorroga = this.numeroserial + "-prorroga"
    //this.numeroserialapoderado = this.numeroserial + "-apoderado"
    this.extensionForm.controls["justificationRejection"].disable();
    this.extensionForm.controls["aduanaIngreso"].disable();
    this.extensionForm.controls["noDiasAutorizados"].disable();
    this.extensionForm.controls["fechaInicioProrroga"].disable();
    this.extensionForm.controls["fechaFinProrroga"].disable();
    this.extensionForm.controls["ciudadHospedajeTurista"].disable();
    this.extensionForm.controls["direccionHospedajeTurista"].disable();
    this.extensionForm.controls["carMedioTransporte"].disable();
    this.extensionForm.controls["tipoIdApoderado"].disable();
    this.extensionForm.controls["numeroIdApoderado"].disable();
    this.extensionForm.controls["nombreRazonSocialApoderado"].disable();
    this.extensionForm.controls["correoElectronicoApoderado"].disable();

    this.http.get<any>(`${environment.baseUrl}v1/import/1?email=&numeroserial=&status=&passportnumber=&importdate=&idimport=` + this.idImport + "&approvednumber=&sectionaladdresin=")
      .subscribe({
        next: data => {
          this.imports = data as Import[];
          this.import = this.imports[0];          
          this.today = new Date(this.import.dateOut).toJSON().split('T')[0];
          this.dateend = new Date(this.import.dateOut).toJSON().split('T')[0];
          this.email = this.import.email
          this.numeroserial = this.import.chassisNumber
          this.seccionalsalida = this.import.sectionalAddressOut

          this.http.get<any>(`${environment.baseUrl}v1/extend/1?idImport=` + this.import.id + "&sectionaladdress=&status=" + ((this.volver == "manage-import" || this.volver == "finish-import") && this.postId == "0" ? "4" : "") + "&idextend=" + ((this.volver == "manage-import" || this.volver == "finish-import") && this.postId == "0" ? "" : this.postId))
            .subscribe({
              next: datae => {
                this.extends = datae as Extend[];
                this.extend = this.extends[0];

                this.extensionForm.patchValue({
                  aduanaIngreso: this.extend.sectionalAddress,
                  noDiasAutorizados: this.extend.authorizedDuration,
                  fechaInicioProrroga: (this.extend.initialDate == "1900-01-01" ? "" : this.extend.initialDate),
                  fechaFinProrroga: (this.extend.endDate == "1900-01-01" ? "" : this.extend.endDate),
                  ciudadHospedajeTurista: this.extend.touristCity,
                  direccionHospedajeTurista: this.extend.touristAddress,
                  carMedioTransporte: this.extend.justification,
                  tipoIdApoderado: this.extend.tidAssignee,
                  numeroIdApoderado: this.extend.idAssignee,
                  nombreRazonSocialApoderado: this.extend.nameAssignee,
                  correoElectronicoApoderado: this.extend.emailAssignee,
                  justificationRejection: this.extend.justificationRejection,
                });

                this.postId = this.extend.id;
                this.numeroserialprorroga = this.extend.nombreContenedor + "-prorroga"
                this.numeroserialapoderado = this.extend.nombreContenedor + "-apoderado"
                this.mandatocheckSi = (this.extend.authorization == "True" ? true : false);
                this.mandatocheckNo = (this.extend.authorization == "True" ? false : true);
                this.solicitudmandato = (this.extend.authorization == "True" ? "1" : "0");
                this.ApoderadoShow = (this.extend.authorization == "True" ? true : false);
                this.idestado = this.extend.idStatus;
                this.estado = (this.extend.idStatus == "1" ? "EN REVISIÓN" : (this.extend.idStatus == "2" ? "APROBADA" : (this.extend.idStatus == "3" ? "RECHAZADA" : (this.extend.idStatus == "4" ? "SOLICITUD PRÓRROGA" : (this.extend.idStatus == "5" ? "PRORROGA APROBADA" : (this.extend.idStatus == "6" ? "VENCIDA" : (this.extend.idStatus == "7" ? "FINALIZADA" : "")))))))
                this.fecharegistro = this.extend.registrationDate.substring(0, 10);
                this.nombreturista = this.import.touristName;
                this.pasaporte = this.import.passportNumber;


                if (this.extend.idStatus == "1") {
                  this.ShowRejection = false;
                }
                else if (this.extend.idStatus == "2") {
                  this.ShowRejection = false;
                }
                else if (this.extend.idStatus == "3") {
                  this.ShowRejection = true;
                }
                else if (this.extend.idStatus == "4") {
                  this.ShowRejection = false;
                }
                else if (this.extend.idStatus == "5") {
                  this.ShowRejection = false;
                }
                else if (this.extend.idStatus == "6") {
                  this.ShowRejection = false;
                }
                else if (this.extend.idStatus == "7") {
                  this.ShowRejection = false;
                }

                this.http.get<any>(`${environment.baseUrl}v1/parametros/1?codigo=`)
                  .subscribe({
                    next: data => {
                      this.Seccionales = data as SeccionalAduanera[];
                      this.tooladuanaIngreso = this.Seccionales.filter(se => se.codigo == this.extend.sectionalAddress)[0].nombre;
                    },
                    error: error => {
                      this.errorMessage = error.message;
                      //console.error('There was an error!', error);
                    }
                  })

                this.http.get<any>(`${environment.baseUrl}v1/parametros/3?codigo=`)
                  .subscribe({
                    next: data => {
                      this.Ciudades = data as Ciudad[];
                      this.toolciudadHospedajeId = this.Ciudades.filter(se => se.codigo == this.extend.touristCity)[0].nombre;
                    },
                    error: error => {
                      this.errorMessage = error.message;
                      
                    }
                  })

                this.http.get<any>(`${environment.baseUrl}v1/parametros/6?codigo=`)
                  .subscribe({
                    next: data => {
                      this.TiposID = data as TipoIdentificacion[];
                      this.tooltipoIdApoderado = this.TiposID.filter(se => se.codigo == this.extend.tidAssignee)[0].nombre;
                    },
                    error: error => {
                      this.errorMessage = error.message;
                      //console.error('There was an error!', error);
                    }
                  })

                this.http.get<any>(`${environment.baseUrl}v1/extend/1?idImport=` + this.import.id + "&sectionaladdress=&status=&idextend=")
                  .subscribe({
                    next: data => {
                      var extends2 = data as Extend[];
                      var extend2 = extends2[1];

                      if (extend2 == null) {
                      }
                      else {
                        var date2: Date = new Date(extend2.endDate)
                        date2.setDate(date2.getDate() + 1);
                        this.today = date2.toJSON().split('T')[0];
                        this.dateend = date2.toJSON().split('T')[0];
                      }
                    },
                    error: error => {
                      this.errorMessage = error.message;
                      //console.error('There was an error!', error);
                    }
                  })

                let element1: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                element1.click();
              },
              error: error => {
                this.errorMessage = error.message;
                //console.error('There was an error!', error);
              }
            })
            
        },
        error: error => {
          this.errorMessage = error.message;
          //console.error('There was an error!', error);
        }
      })


    

  }

  saveExtend() {
    let element: HTMLElement = document.getElementById('abrircargando') as HTMLElement;
    element.click();
    if (this.extensionForm.valid) {
      var tidAssignee = this.extensionForm.controls["tipoIdApoderado"].value;
      var idAssignee = this.extensionForm.controls["numeroIdApoderado"].value;
      var nameAssignee = this.extensionForm.controls["nombreRazonSocialApoderado"].value;
      var emailAssignee = this.extensionForm.controls["correoElectronicoApoderado"].value;

      if (this.solicitudmandato == "1" && (tidAssignee == "" || idAssignee == "" || nameAssignee == "" || emailAssignee == "")) {
        let element1: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
        element1.click();

        if (this.solicitudmandato == "1") {
          this.cambiotipoIdApoderado();
          this.cambionumeroIdApoderado();
          this.cambionombreRazonSocialApoderado();
          this.cambiocorreoElectronicoApoderado();
        }

        let element: HTMLElement = document.getElementById('abrirmodalerror') as HTMLElement;
        element.click();
        if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
          this.errorMessage = "Algunos datos obligatorios están sin diligenciar o están mal diligenciados, por favor";
        } else {
          this.errorMessage = "Some mandatory information is incomplete or incorrectly filled out, please";
        }
      }
      else {
        this.http.get<any>(`${environment.baseUrl}v1/import/1?email=` + this.email + "&numeroserial=" + this.numeroserial + "&status=&passportnumber=&importdate=&idimport=" + this.idImport + "&approvednumber=&sectionaladdresin=")
          .subscribe({
            next: data => {
              this.imports = data as Import[];
              this.import = this.imports[0];

              this.extend = new Extend();
              this.extend.sectionalAddress = this.extensionForm.controls["aduanaIngreso"].value;
              this.extend.authorizedDuration = this.extensionForm.controls["noDiasAutorizados"].value;
              this.extend.initialDate = this.extensionForm.controls["fechaInicioProrroga"].value;
              this.extend.endDate = this.extensionForm.controls["fechaFinProrroga"].value;
              this.extend.touristCity = this.extensionForm.controls["ciudadHospedajeTurista"].value;
              this.extend.touristAddress = this.extensionForm.controls["direccionHospedajeTurista"].value;
              this.extend.justification = this.extensionForm.controls["carMedioTransporte"].value;
              this.extend.authorization = this.solicitudmandato;
              this.extend.tidAssignee = this.extensionForm.controls["tipoIdApoderado"].value;
              this.extend.idAssignee = this.extensionForm.controls["numeroIdApoderado"].value;
              this.extend.nameAssignee = this.extensionForm.controls["nombreRazonSocialApoderado"].value;
              this.extend.emailAssignee = this.extensionForm.controls["correoElectronicoApoderado"].value;
              this.extend.registrationDate = this.fecharegistro;
              this.extend.idImport = this.import.id;
              this.extend.idStatus = this.idestado;

              const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
              this.http.put<any>(`${environment.baseUrl}v1/extend/` + this.postId, this.extend, { headers })
                .subscribe({
                  next: data => {
                    this.extend = data as Extend;
                    this.postId = this.extend.id;
                    this.extensionForm.controls["aduanaIngreso"].disable();
                    this.extensionForm.controls["noDiasAutorizados"].disable();
                    this.extensionForm.controls["fechaInicioProrroga"].disable();
                    this.extensionForm.controls["fechaFinProrroga"].disable();
                    this.extensionForm.controls["ciudadHospedajeTurista"].disable();
                    this.extensionForm.controls["direccionHospedajeTurista"].disable();
                    this.extensionForm.controls["carMedioTransporte"].disable();
                    this.extensionForm.controls["tipoIdApoderado"].disable();
                    this.extensionForm.controls["numeroIdApoderado"].disable();
                    this.extensionForm.controls["nombreRazonSocialApoderado"].disable();
                    this.extensionForm.controls["correoElectronicoApoderado"].disable();
                    if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                      this.okMessage = "¡Solicitud actualizada con éxito!";
                    } else {
                      this.okMessage = "Application updated successfully!";
                    }
                    this.EditarShow = false;

                    this.tooladuanaIngreso = this.Seccionales.filter(se => se.codigo == this.extend.sectionalAddress)[0].nombre;
                    this.toolciudadHospedajeId = this.Ciudades.filter(se => se.codigo == this.extend.touristCity)[0].nombre;
                    if (this.solicitudmandato == "1") {
                      this.tooltipoIdApoderado = this.TiposID.filter(se => se.codigo == this.extend.tidAssignee)[0].nombre;
                    }
                    

                    let element2: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                    element2.click();

                    let element: HTMLElement = document.getElementById('abrirmodal') as HTMLElement;
                    element.click();
                  },
                  error: error => {
                    this.errorMessage = error.message;
                    //console.error('There was an error!', error);
                    let element3: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                    element3.click();
                  }
                })

            },
            error: error => {
              this.errorMessage = error.message;
              if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                this.errorMessage = "Algo salió mal, por favor";
              } else {
                this.errorMessage = "Something went wrong, please";
              }
              let element4: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
              element4.click();
            }
          })
      }
    } else {
      this.validarcampos();
      var mandato = this.solicitudmandato;
      if (mandato == "1") {
        this.cambiotipoIdApoderado();
        this.cambionumeroIdApoderado();
        this.cambionombreRazonSocialApoderado();
        this.cambiocorreoElectronicoApoderado();
      }
      let element5: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
      element5.click();
      let element: HTMLElement = document.getElementById('abrirmodalerror') as HTMLElement;
      element.click();
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.errorMessage = "Algunos datos obligatorios están sin diligenciar o están mal diligenciados, por favor";
      } else {
        this.errorMessage = "Some mandatory information is incomplete or incorrectly filled out, please";
      }
    }
  }

  cambiarSi(isChecked: boolean) {
    this.cambiotipoIdApoderado();
    this.cambionumeroIdApoderado();
    this.cambionombreRazonSocialApoderado();
    this.cambiocorreoElectronicoApoderado();
    if (isChecked) {
      this.solicitudmandato = "1";
      this.ApoderadoShow = true;
      this.mandatocheckSi = true;
      this.mandatocheckNo = false;
    }
    else {
      this.solicitudmandato = "0";
      this.ApoderadoShow = false;
      this.mandatocheckSi = false;
      this.mandatocheckNo = true;
      this.extensionForm.patchValue({
        tipoIdApoderado: "",
        numeroIdApoderado: "",
        nombreRazonSocialApoderado: "",
        correoElectronicoApoderado: ""
      });
    }
    this.errortipoIdApoderado = false;
    this.errornumeroIdApoderado = false;
    this.errornombreRazonSocialApoderado = false;
    this.errorcorreoElectronicoApoderado = false;
  }

  cambiarNo(isChecked: boolean) {
    this.cambiotipoIdApoderado();
    this.cambionumeroIdApoderado();
    this.cambionombreRazonSocialApoderado();
    this.cambiocorreoElectronicoApoderado();
    if (isChecked) {
      this.solicitudmandato = "0";
      this.ApoderadoShow = false;
      this.mandatocheckSi = false;
      this.mandatocheckNo = true;
      this.extensionForm.patchValue({
        tipoIdApoderado: "",
        numeroIdApoderado: "",
        nombreRazonSocialApoderado: "",
        correoElectronicoApoderado: ""
      });
      this.errortipoIdApoderado = false;
      this.errornumeroIdApoderado = false;
      this.errornombreRazonSocialApoderado = false;
      this.errorcorreoElectronicoApoderado = false;
    }
    else {
      this.solicitudmandato = "1";
      this.ApoderadoShow = true;
      this.mandatocheckSi = true;
      this.mandatocheckNo = false;
    }

  }

  editar() {
    this.extensionForm.controls["aduanaIngreso"].enable();
    this.extensionForm.controls["noDiasAutorizados"].enable();
    this.extensionForm.controls["fechaInicioProrroga"].enable();
    this.extensionForm.controls["fechaFinProrroga"].enable();
    this.extensionForm.controls["ciudadHospedajeTurista"].enable();
    this.extensionForm.controls["direccionHospedajeTurista"].enable();
    this.extensionForm.controls["carMedioTransporte"].enable();
    this.extensionForm.controls["tipoIdApoderado"].enable();
    this.extensionForm.controls["numeroIdApoderado"].enable();
    this.extensionForm.controls["nombreRazonSocialApoderado"].enable();
    this.extensionForm.controls["correoElectronicoApoderado"].enable();

    this.EditarShow = true;
  }

  cancelar() {
    this.extensionForm.controls["aduanaIngreso"].disable();
    this.extensionForm.controls["noDiasAutorizados"].disable();
    this.extensionForm.controls["fechaInicioProrroga"].disable();
    this.extensionForm.controls["fechaFinProrroga"].disable();
    this.extensionForm.controls["ciudadHospedajeTurista"].disable();
    this.extensionForm.controls["direccionHospedajeTurista"].disable();
    this.extensionForm.controls["carMedioTransporte"].disable();
    this.extensionForm.controls["tipoIdApoderado"].disable();
    this.extensionForm.controls["numeroIdApoderado"].disable();
    this.extensionForm.controls["nombreRazonSocialApoderado"].disable();
    this.extensionForm.controls["correoElectronicoApoderado"].disable();

    this.errordiasAutorizadosId = false;
    this.erroraduanaIngreso = false;
    this.errornoDiasAutorizados = false;
    this.errorfechaInicioProrroga = false;
    this.errorfechaFinProrroga = false;
    this.errorciudadHospedajeTurista = false;
    this.errordireccionHospedajeTurista = false;
    this.errorcarMedioTransporte = false;
    this.errortipoIdApoderado = false;
    this.errornumeroIdApoderado = false;
    this.errornombreRazonSocialApoderado = false;
    this.errorcorreoElectronicoApoderado = false;

    this.EditarShow = false;

    this.extensionForm.patchValue({
      aduanaIngreso: this.extend.sectionalAddress,
      noDiasAutorizados: this.extend.authorizedDuration,
      fechaInicioProrroga: (this.extend.initialDate == "1900-01-01" ? "" : this.extend.initialDate),
      fechaFinProrroga: (this.extend.endDate == "1900-01-01" ? "" : this.extend.endDate),
      ciudadHospedajeTurista: this.extend.touristCity,
      direccionHospedajeTurista: this.extend.touristAddress,
      carMedioTransporte: this.extend.justification,
      tipoIdApoderado: this.extend.tidAssignee,
      numeroIdApoderado: this.extend.idAssignee,
      nombreRazonSocialApoderado: this.extend.nameAssignee,
      correoElectronicoApoderado: this.extend.emailAssignee,
      justificationRejection: this.extend.justificationRejection,
    });

    this.postId = this.extend.id;

    this.mandatocheckSi = (this.extend.authorization == "True" ? true : false);
    this.mandatocheckNo = (this.extend.authorization == "True" ? false : true);
    this.solicitudmandato = (this.extend.authorization == "True" ? "1" : "0");
    this.ApoderadoShow = (this.extend.authorization == "True" ? true : false);
  }

  aprobar() {
    let element: HTMLElement = document.getElementById('abrircargando') as HTMLElement;
    element.click();
    this.editar();
    if (this.extensionForm.valid) {
      this.cancelar();
      var tidAssignee = this.extensionForm.controls["tipoIdApoderado"].value;
      var idAssignee = this.extensionForm.controls["numeroIdApoderado"].value;
      var nameAssignee = this.extensionForm.controls["nombreRazonSocialApoderado"].value;
      var emailAssignee = this.extensionForm.controls["correoElectronicoApoderado"].value;

      if (this.solicitudmandato == "1" && (tidAssignee == "" || idAssignee == "" || nameAssignee == "" || emailAssignee == "")) {
        let element1: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
        element1.click();

        if (this.solicitudmandato == "1") {
          this.cambiotipoIdApoderado();
          this.cambionumeroIdApoderado();
          this.cambionombreRazonSocialApoderado();
          this.cambiocorreoElectronicoApoderado();
        }

        let element2: HTMLElement = document.getElementById('abrirmodalerror') as HTMLElement;
        element2.click();
        if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
          this.errorMessage = "Algunos datos obligatorios están sin diligenciar o están mal diligenciados, por favor";
        } else {
          this.errorMessage = "Some mandatory information is incomplete or incorrectly filled out, please";
        }
      }
      else {
        this.http.get<any>(`${environment.baseUrl}v1/import/1?email=` + this.email + "&numeroserial=" + this.numeroserial + "&status=&passportnumber=&importdate=&idimport=" + this.idImport + "&approvednumber=&sectionaladdresin=")
          .subscribe({
            next: data => {
              this.imports = data as Import[];
              this.import = this.imports[0];

              this.extend = new Extend();
              this.extend.sectionalAddress = this.extensionForm.controls["aduanaIngreso"].value;
              this.extend.authorizedDuration = this.extensionForm.controls["noDiasAutorizados"].value;
              this.extend.initialDate = this.extensionForm.controls["fechaInicioProrroga"].value;
              this.extend.endDate = this.extensionForm.controls["fechaFinProrroga"].value;
              this.extend.touristCity = this.extensionForm.controls["ciudadHospedajeTurista"].value;
              this.extend.touristAddress = this.extensionForm.controls["direccionHospedajeTurista"].value;
              this.extend.justification = this.extensionForm.controls["carMedioTransporte"].value;
              this.extend.authorization = this.solicitudmandato;
              this.extend.tidAssignee = this.extensionForm.controls["tipoIdApoderado"].value;
              this.extend.idAssignee = this.extensionForm.controls["numeroIdApoderado"].value;
              this.extend.nameAssignee = this.extensionForm.controls["nombreRazonSocialApoderado"].value;
              this.extend.emailAssignee = this.extensionForm.controls["correoElectronicoApoderado"].value;
              this.extend.registrationDate = this.fecharegistro;
              this.extend.idImport = this.import.id;
              this.extend.managerUserName = this.user.nombres + " " + this.user.apellidos;
              this.extend.managerUserId = this.user.numIdentificacion;
              this.extend.idStatus = "5";

              const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
              this.http.put<any>(`${environment.baseUrl}v1/extend/` + this.postId, this.extend, { headers })
                .subscribe({
                  next: data => {
                    this.extend = data as Extend;
                    this.numeroautorizacion = this.extend.approvedNumber;
                    this.extensionForm.controls["aduanaIngreso"].disable();
                    this.extensionForm.controls["noDiasAutorizados"].disable();
                    this.extensionForm.controls["fechaInicioProrroga"].disable();
                    this.extensionForm.controls["fechaFinProrroga"].disable();
                    this.extensionForm.controls["ciudadHospedajeTurista"].disable();
                    this.extensionForm.controls["direccionHospedajeTurista"].disable();
                    this.extensionForm.controls["carMedioTransporte"].disable();
                    this.extensionForm.controls["tipoIdApoderado"].disable();
                    this.extensionForm.controls["numeroIdApoderado"].disable();
                    this.extensionForm.controls["nombreRazonSocialApoderado"].disable();
                    this.extensionForm.controls["correoElectronicoApoderado"].disable();
                    if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                      this.okMessage = "¡Prorroga aprobada con éxito!";
                    } else {
                      this.okMessage = "Extension approved successfully!";
                    }
                    this.EditarShow = false;
                    this.estado = "PRORROGA APROBADA";
                    this.GestionarShow = false;
                    this.ConsultarShow = true;
                    this.accion = "consulta";

                    let element3: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                    element3.click();

                    let element4: HTMLElement = document.getElementById('abrirmodal') as HTMLElement;
                    element4.click();

                    this.http.get<any>(`${environment.baseUrl}v1/token/1`)
                      .subscribe({
                        next: data => {
                          this.sendmail = data as SendMail;
                          this.sendmail.asunto = "Autorización de la prórroga de importación temporal de turismo";
                          this.sendmail.email = this.import.email;
                          this.sendmail.emailCopy = "null";
                          this.sendmail.mensaje = "<table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td><table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td style='font-size: 25px; font-family: Helvetica, Arial, sans-serif; color: #262944; padding-top: 30px;' class='padding-copy'><b>Notificación de servicio</b><br/><span style='font-size: 20px;'>Autorización de la prórroga de importación temporal de turismo</span> </td></tr><tr><td style='padding: 30px 0 0 0; font-size: 16px; line-height: 22px; font-family: Helvetica, Arial, sans-serif; color: #2B323D;' class='padding-copy'><p>Buen día,</p><p><span style='font-weight: bold;'>" + this.import.touristName + "</span></p><p style='padding: 30px 0 0 0;'>Tu solicitud de <span style='font-weight: bold;'>prórroga de importación temporal de turismo</span> del medio de transporte con número de identificación (VIN o Serial) <span style='font-weight: bold;'>" + this.import.chassisNumber + "</span> ha sido:</p><table width='100%' border='0' cellspacing='0' cellpadding='0' class='mobile-button-container'><tr><td align='center' style='padding: 25px 0 0 0;' class='padding-copy'><table border='0' cellspacing='0' cellpadding='0' class='responsive-table'><tr><td align='center'><a style='border: 0;background: #d5f4e6;display: inline-block;text-align: center;padding: 5px 20px 5px 20px;border: 2px solid #d5f4e6;outline: none;color: #38bf7c;font-size: 16px;font-family: WorkSans-Bold;border-radius: 5px;transition: 0.25s;cursor: none;'><b>Autorizada</b></a></td></tr></table></td></tr></table><p style='padding: 30px 0 0 0;'>Número de autorización: <span style='font-weight: bold;'>" + this.numeroautorizacion + "</span></p><p style='padding: 0px 0 0 0;'>Término de días autorizados: <span style='font-weight: bold;'>" + this.extend.authorizedDuration + " días</span></p><p style='padding: 0px 0 0 0;'>Autorizada hasta la fecha: <span style='font-weight: bold;'>" + this.extend.endDate + "</span></p><p style='padding:20px 20px 20px 20px;background-color: #ccf0f8;'>Para evitar sanciones recuerda que la misma debe ser finalizada o prorrogada ante la autoridad aduanera antes del vencimiento del término señalado.</p><p style='padding: 40px 0 0 0;'>Cordialmente,</p><p><span style='font-weight: bold;'>Dirección de Impuestos y Aduanas Nacionales - DIAN</span></p><p style='padding: 0 0 0 0;'>Gestión de Operación Aduanera</p></td></tr></table></td></tr></table>";

                          this.http.post<string>(`${environment.baseUrl}v1/sendmail`, this.sendmail, { headers })
                            .subscribe({
                              next: data => {

                              },
                              error: error => {
                                this.errorMessage = error.message;
                              }
                            })
                        },
                        error: error => {
                          this.errorMessage = error.message;
                        }
                      })
                  },
                  error: error => {
                    this.errorMessage = error.message;
                    if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                      this.errorMessage = "Algo salió mal, por favor";
                    } else {
                      this.errorMessage = "Something went wrong, please";
                    }
                    let element5: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                    element5.click();
                  }
                })

            },
            error: error => {
              this.errorMessage = error.message;
              if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                this.errorMessage = "Algo salió mal, por favor";
              } else {
                this.errorMessage = "Something went wrong, please";
              }
              let element6: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
              element6.click();
            }
          })
      }
    } else {
      this.validarcampos();
      var mandato = this.solicitudmandato;
      if (mandato == "1") {
        this.cambiotipoIdApoderado();
        this.cambionumeroIdApoderado();
        this.cambionombreRazonSocialApoderado();
        this.cambiocorreoElectronicoApoderado();
      }
      let element7: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
      element7.click();
      let element8: HTMLElement = document.getElementById('abrirmodalerror') as HTMLElement;
      element8.click();
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.errorMessage = "Algunos datos obligatorios están sin diligenciar o están mal diligenciados, por favor";
      } else {
        this.errorMessage = "Some mandatory information is incomplete or incorrectly filled out, please";
      }
    }
  }

  rechazar() {
    let element: HTMLElement = document.getElementById('cerrarmodal') as HTMLElement;
    element.click();
    let element1: HTMLElement = document.getElementById('abrircargando') as HTMLElement;
    element1.click();

    this.http.get<any>(`${environment.baseUrl}v1/import/1?email=` + this.email + "&numeroserial=" + this.numeroserial + "&status=&passportnumber=&importdate=&idimport=" + this.idImport + "&approvednumber=&sectionaladdresin=")
      .subscribe({
        next: data => {
          this.imports = data as Import[];
          this.import = this.imports[0];

          this.extend = new Extend();
          this.extend.sectionalAddress = this.extensionForm.controls["aduanaIngreso"].value;
          this.extend.authorizedDuration = this.extensionForm.controls["noDiasAutorizados"].value;
          this.extend.initialDate = this.extensionForm.controls["fechaInicioProrroga"].value;
          this.extend.endDate = this.extensionForm.controls["fechaFinProrroga"].value;
          this.extend.touristCity = this.extensionForm.controls["ciudadHospedajeTurista"].value;
          this.extend.touristAddress = this.extensionForm.controls["direccionHospedajeTurista"].value;
          this.extend.justification = this.extensionForm.controls["carMedioTransporte"].value;
          this.extend.authorization = this.solicitudmandato;
          this.extend.tidAssignee = this.extensionForm.controls["tipoIdApoderado"].value;
          this.extend.idAssignee = this.extensionForm.controls["numeroIdApoderado"].value;
          this.extend.nameAssignee = this.extensionForm.controls["nombreRazonSocialApoderado"].value;
          this.extend.emailAssignee = this.extensionForm.controls["correoElectronicoApoderado"].value;
          this.extend.justificationRejection = this.extensionForm.controls["justification"].value;
          this.extend.registrationDate = this.fecharegistro;
          this.extend.idImport = this.import.id;
          this.extend.managerUserName = this.user.nombres + " " + this.user.apellidos;
          this.extend.managerUserId = this.user.numIdentificacion;
          this.extend.idStatus = "3";

          const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
          this.http.put<any>(`${environment.baseUrl}v1/extend/` + this.postId, this.extend, { headers })
            .subscribe({
              next: data => {
                this.extend = data as Extend;
                this.postId = this.extend.id;
                this.extensionForm.controls["aduanaIngreso"].disable();
                this.extensionForm.controls["noDiasAutorizados"].disable();
                this.extensionForm.controls["fechaInicioProrroga"].disable();
                this.extensionForm.controls["fechaFinProrroga"].disable();
                this.extensionForm.controls["ciudadHospedajeTurista"].disable();
                this.extensionForm.controls["direccionHospedajeTurista"].disable();
                this.extensionForm.controls["carMedioTransporte"].disable();
                this.extensionForm.controls["tipoIdApoderado"].disable();
                this.extensionForm.controls["numeroIdApoderado"].disable();
                this.extensionForm.controls["nombreRazonSocialApoderado"].disable();
                this.extensionForm.controls["correoElectronicoApoderado"].disable();
                if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                  this.okMessage = "¡Prorroga rechazada con éxito!";
                } else {
                  this.okMessage = "Extension successfully rejected!";
                }
                this.EditarShow = false;
                this.estado = "RECHAZADA";
                this.GestionarShow = false;
                this.ConsultarShow = true;
                this.accion = "consulta";

                let element3: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                element3.click();

                let element: HTMLElement = document.getElementById('abrirmodal') as HTMLElement;
                element.click();

                this.http.get<any>(`${environment.baseUrl}v1/token/1`)
                  .subscribe({
                    next: data => {
                      this.sendmail = data as SendMail;
                      this.sendmail.asunto = "Rechazo de la prórroga de importación temporal de turismo";
                      this.sendmail.email = this.import.email;
                      this.sendmail.emailCopy = "null";
                      this.sendmail.mensaje = "<table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td><table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td style='font-size: 25px; font-family: Helvetica, Arial, sans-serif; color: #262944; padding-top: 30px;' class='padding-copy'><b>Notificación de servicio</b><br/><span style='font-size: 20px;'>Rechazo de la prórroga de importación temporal de turismo</span> </td></tr><tr><td style='padding: 30px 0 0 0; font-size: 16px; line-height: 22px; font-family: Helvetica, Arial, sans-serif; color: #2B323D;' class='padding-copy'><p>Buen día,</p><p><span style='font-weight: bold;'>" + this.import.touristName + "</span></p><p style='padding: 30px 0 0 0;'>Tu solicitud de <span style='font-weight: bold;'>prórroga de importación temporal de turismo</span> del medio de transporte con número de identificación (VIN o Serial) <span style='font-weight: bold;'>" + this.import.chassisNumber + "</span> ha sido:</p><table width='100%' border='0' cellspacing='0' cellpadding='0' class='mobile-button-container'><tr><td align='center' style='padding: 25px 0 0 0;' class='padding-copy'><table border='0' cellspacing='0' cellpadding='0' class='responsive-table'><tr><td align='center'><a style='border: 0;background: #FCD5D3;display: inline-block;text-align: center;padding: 5px 20px 5px 20px;border: 2px solid #FCD5D3;outline: none;color: #F8918A;font-size: 16px;font-family: WorkSans-Bold;border-radius: 5px;transition: 0.25s;cursor: none;'><b>Rechazada</b></a></td></tr></table></td></tr></table><p style='padding: 40px 0 0 0;'>Cordialmente,</p><p><span style='font-weight: bold;'>Dirección de Impuestos y Aduanas Nacionales - DIAN</span></p><p style='padding: 0 0 0 0;'>Gestión de Operación Aduanera</p></td></tr></table></td></tr></table>";

                      this.http.post<string>(`${environment.baseUrl}v1/sendmail`, this.sendmail, { headers })
                        .subscribe({
                          next: data => {

                          },
                          error: error => {
                            this.errorMessage = error.message;
                          }
                        })
                    },
                    error: error => {
                      this.errorMessage = error.message;
                    }
                  })
              },
              error: error => {
                this.errorMessage = error.message;
                if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                  this.errorMessage = "Algo salió mal, por favor";
                } else {
                  this.errorMessage = "Something went wrong, please";
                }

                let element4: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                element4.click();
              }
            })

        },
        error: error => {
          this.errorMessage = error.message;
          if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
            this.errorMessage = "Algo salió mal, por favor";
          } else {
            this.errorMessage = "Something went wrong, please";
          }

          let element5: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
          element5.click();
        }
      })
  }

  versolicitud() {
    this.router.navigate(["/import-back/" + this.accion + "/" + this.email + "/" + this.numeroserial + "/" + this.idImport + "/" + this.volver]);
  }

  salir() {
    if (this.volver == "manage-import" || this.volver == "finish-import") {
      this.router.navigate(["/" + this.volver]);
    }
    else {
      this.router.navigate(["/" + this.volver + "/" + this.idImport]);
    }  
  }

  cambiofechainicio() {
    this.cambiofechaInicioProrroga();
    var fecha = this.extensionForm.controls["fechaInicioProrroga"].value;
    if (fecha == "") {
      this.extensionForm.patchValue({
        fechaFinProrroga: ""
      });
      this.dateend = new Date().toJSON().split('T')[0];
    } else {
      var dateselect = new Date(fecha).toJSON().split('T')[0];
      var today = new Date().toJSON().split('T')[0];
      if (dateselect < today) {
        this.extensionForm.patchValue({
          fechaInicioProrroga: "",
          fechaFinProrroga: ""
        });
        this.dateend = new Date().toJSON().split('T')[0];
      } else {
        this.dateend = new Date(fecha).toJSON().split('T')[0];
      }
    }
  }

  cambiofechafin() {
    this.cambiofechaFinProrroga();
    var fechai = this.extensionForm.controls["fechaInicioProrroga"].value;
    var fechaf = this.extensionForm.controls["fechaFinProrroga"].value;
    if (fechaf != "") {
      if (fechai != "") {
        var datei = new Date(fechai).toJSON().split('T')[0];
        var datef = new Date(fechaf).toJSON().split('T')[0];
        if (datei > datef) {
          this.extensionForm.patchValue({
            fechaFinProrroga: ""
          });
        } else {

        }
      }
      else {
        var datei = new Date().toJSON().split('T')[0];
        var datef = new Date(fechaf).toJSON().split('T')[0];
        if (datei > datef) {
          this.extensionForm.patchValue({
            fechaFinProrroga: ""
          });
        } else {

        }
      }
    }

  }

  validatediasAutorizadosId() {
    this.cambionoDiasAutorizados();
    var regexp = new RegExp(/^[0-9]*$/);
    var valor = this.extensionForm.controls["noDiasAutorizados"].value;

    if (!regexp.test(valor)) {
      this.errordiasAutorizadosId = true;
    }
    else {
      this.errordiasAutorizadosId = false;
    }
  }

  validarcampos() {
    this.cambioaduanaIngreso();
    this.cambionoDiasAutorizados();
    this.cambiofechaInicioProrroga();
    this.cambiofechaFinProrroga();
    this.cambiociudadHospedajeTurista();
    this.cambiodireccionHospedajeTurista();
    this.cambiocarMedioTransporte();
  }

  cambioaduanaIngreso() {
    var valor = this.extensionForm.controls["aduanaIngreso"].value;
    if (valor == "") {
      this.erroraduanaIngreso = true;
    }
    else {
      this.erroraduanaIngreso = false;
    }
  }
  cambionoDiasAutorizados() {
    var valor = this.extensionForm.controls["noDiasAutorizados"].value;
    if (valor == "") {
      this.errornoDiasAutorizados = true;
    }
    else {
      this.errornoDiasAutorizados = false;
    }
  }
  cambiofechaInicioProrroga() {
    var valor = this.extensionForm.controls["fechaInicioProrroga"].value;
    if (valor == "") {
      this.errorfechaInicioProrroga = true;
    }
    else {
      this.errorfechaInicioProrroga = false;
    }
  }
  cambiofechaFinProrroga() {
    var valor = this.extensionForm.controls["fechaFinProrroga"].value;
    if (valor == "") {
      this.errorfechaFinProrroga = true;
    }
    else {
      this.errorfechaFinProrroga = false;
    }
  }
  cambiociudadHospedajeTurista() {
    var valor = this.extensionForm.controls["ciudadHospedajeTurista"].value;
    if (valor == "") {
      this.errorciudadHospedajeTurista = true;
    }
    else {
      this.errorciudadHospedajeTurista = false;
    }
  }
  cambiodireccionHospedajeTurista() {
    var valor = this.extensionForm.controls["direccionHospedajeTurista"].value;
    if (valor == "") {
      this.errordireccionHospedajeTurista = true;
    }
    else {
      this.errordireccionHospedajeTurista = false;
    }
  }
  cambiocarMedioTransporte() {
    var valor = this.extensionForm.controls["carMedioTransporte"].value;
    if (valor == "") {
      this.errorcarMedioTransporte = true;
    }
    else {
      this.errorcarMedioTransporte = false;
    }
  }
  cambiotipoIdApoderado() {
    var valor = this.extensionForm.controls["tipoIdApoderado"].value;
    if (valor == "") {
      this.errortipoIdApoderado = true;
    }
    else {
      this.errortipoIdApoderado = false;
    }
  }
  cambionumeroIdApoderado() {
    var valor = this.extensionForm.controls["numeroIdApoderado"].value;
    if (valor == "") {
      this.errornumeroIdApoderado = true;
    }
    else {
      this.errornumeroIdApoderado = false;
    }
  }
  cambionombreRazonSocialApoderado() {
    var valor = this.extensionForm.controls["nombreRazonSocialApoderado"].value;
    if (valor == "") {
      this.errornombreRazonSocialApoderado = true;
    }
    else {
      this.errornombreRazonSocialApoderado = false;
    }
  }
  cambiocorreoElectronicoApoderado() {
    var valor = this.extensionForm.controls["correoElectronicoApoderado"].value;
    if (valor == "") {
      this.errorcorreoElectronicoApoderado = true;
    }
    else {
      this.errorcorreoElectronicoApoderado = false;
    }
  }
}

interface Ciudad {
  codigo: string;
  nombre: string;
}

interface SeccionalAduanera {
  codigo: string;
  nombre: string;
}

interface TipoIdentificacion {
  codigo: string;
  nombre: string;
}

class Import {
  id: string
  sectionalAddressIn: string;
  sectionalAddressOut: string;
  touristName: string;
  touristCountry: string;
  passportNumber: string;
  nationality: string;
  dateOfArrival: string;
  touristCity: string;
  touristAddress: string;
  authorizedDuration: string;
  email: string;
  dateIn: string;
  dateOut: string;
  vehicleEntryForm: string;
  transportDocumentNumber: string;
  n1166DocumentNumber: string;
  ownershipDocumentNumber: string;
  registrationDate: string;
  typeClass: string;
  chassisNumber: string;
  licensePlate: string;
  make: string;
  model: string;
  engineNumber: string;
  countryOfRegistration: string;
  color: string;
  transportationName: string;
  nameFlag: string;
  entryPlace: string;
  registrationNumber: string;
  transportationChars: string;
  othersChars: string;
  idStatus: string;
  importDate: string;
  nombreContenedor: string;  
}

class Extend {
  id: string;
  sectionalAddress: string;
  authorizedDuration: string;
  initialDate: string;
  endDate: string;
  touristCity: string;
  touristAddress: string;
  justification: string;  
  authorization: string;
  tidAssignee: string;
  idAssignee: string;
  nameAssignee: string;
  emailAssignee: string;
  registrationDate: string;
  idImport: string;
  idStatus: string;
  justificationRejection: string;
  approvedNumber: string;
  approvedDate: string;
  managerUserName: string;
  managerUserId: string;
  nombreContenedor: string;
}

class SendMail {
  asunto: string;
  email: string;
  mensaje: string;
  emailCopy: string;
  token: string;
}

class User {
  idToken: string;
  clientId: string;
  tipoDocumento: string;
  numIdentificacion: string;
  nombres: string;
  apellidos: string;
  seccional: string;
  idSeccional: string;
  dependencia: string;
  idDependencia: string;
  correo: string;
  activo: string;
  rolesAutorizados: string;
  infouser: string;
}
